import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { IntlProvider } from "react-intl";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./components/ErrorBoundary";
import MessageWriteErrorBoundary from "./components/MessageWriteErrorBoundary";
import Login from "./components/Login";
import { msalConfig } from "./components/Login/msalConfig";
import ApiHealthCheck from "./components/ApiHealthCheck";
import { LocalStorageToIdb } from "components/LocalStorageToIdb";
import IdbMigration from "./components/IdbMigration";
import AccessGate from "./components/AccessGate";
// Providers
import { UploadProvider } from "contexts/UploadContext";
import { Translations } from "./i18n";
import "./iconLibrary";

const msalInstance = new PublicClientApplication(msalConfig);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <IntlProvider locale={"en"} messages={Translations["en-US"]}>
        <ApiHealthCheck>
          <MsalProvider instance={msalInstance}>
            <Login>
              <QueryClientProvider client={queryClient}>
                {/* Catches a MessagesWriteError from a failed message write and shows
                    a recoverable crash screen (ADR 065).*/}
                <MessageWriteErrorBoundary>
                  <AccessGate>
                    <LocalStorageToIdb>
                      <IdbMigration>
                        <UploadProvider>
                          <App />
                        </UploadProvider>
                      </IdbMigration>
                    </LocalStorageToIdb>
                  </AccessGate>
                </MessageWriteErrorBoundary>

                <ReactQueryDevtools
                  initialIsOpen={false}
                  buttonPosition="bottom-right"
                />
              </QueryClientProvider>
            </Login>
          </MsalProvider>
        </ApiHealthCheck>
      </IntlProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
